export default "__VITE_ASSET__CZ1ubUby__"